import { createSlice } from "@reduxjs/toolkit";

const initialState = { MapClickMode: null };

const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    setMapMode(state, action) {
      state.MapClickMode = action.payload;
    },
  },
});

export const { setMapMode } = mapSlice.actions;

export default mapSlice.reducer;
